require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var Handlebars = require('handlebars');
var GenericView = require('views/generic.view.ts');
var Template = require('text-loader!../templates/reset_password.template.htm');
require('dhtmlxMessage');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: $("#body"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function () {
        this.render();

        this.fields = {
            newPassword: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
            confirmPassword: [this.isEmpty, this.sameValues]
        };
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template());
	},
    events:{
		"submit #form": "reset",
        "click #resetButton": "reset",
		"change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
	},
	validateIt: function(event)
    {
        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        //console.info(field);
        this.validateFields( field );
    },
	reset: function() {
        var self = this;

        var has_error = this.validateFields(this.fields);
        //console.info("has error: " + has_error);

        var newPassword = encodeURIComponent($("#newPassword").find("input").val());
        var confirmPassword = encodeURIComponent($("#confirmPassword").find("input").val());
        var token = location.href.split("?")[1].split("=")[1];

        if(!has_error) {
            $.ajaxDefaultQ({
                url: '/rest/auth/password/reset',
                type: 'POST',
                data: "token=" + token + "&password=" + confirmPassword,
            }).done(function(response, status, xhr){
                //console.info(status);
                if(status == "success")
                {
                    $("#reset-message").html('<i class="fas fa-check check-icon"></i>' + i18n.t("account.passwordResetSuccess"));
                    $("#reset-message").show();
                    setTimeout(function() {
                        window.open('/#Login','_self');
                    }, 2000);
                }
            })
            .fail(function(response) {
                //console.info("Reset Password response failed");
                dhtmlx.alert({
                    type: "alert",
                    text: i18n.t("queue.pswd_wrong"),
                    callback: function (result) {
                        $("#newPassword").find("input").val("");
                        $("#confirmPassword").find("input").val("");
                    }
                });
            })
        }

        return false;
	}
});

module.exports = TheView;